/**
 * =========================================
 * PUJA SANKALP POPUP
 * =========================================
 *
 * Flow:
 *
 * Puja Package Section
 *        ↓
 * puja:booking:start
 *        ↓
 * Open Sankalp Popup
 *        ↓
 * Step 1 - Devotee Details
 * Step 2 - Optional Seva
 * Step 3 - Confirmation
 *        ↓
 * Add Puja + Sevas to Cart
 *        ↓
 * Checkout
 */


function initPujaSankalpPopup() {

  const popups = document.querySelectorAll(
    '[data-puja-sankalp-popup]'
  );

  if (!popups.length) {
    return;
  }


  popups.forEach(function (popup) {

    if (popup.dataset.initialized === 'true') {
      return;
    }


    /**
     * =========================================
     * ELEMENTS
     * =========================================
     */

    const form = popup.querySelector(
      '[data-puja-sankalp-form]'
    );

    const modal = popup.querySelector(
      '.puja-sankalp-modal'
    );

    const closeButtons = popup.querySelectorAll(
      '[data-puja-sankalp-close]'
    );

    const steps = popup.querySelectorAll(
      '[data-puja-step]'
    );

    const stepIndicators = popup.querySelectorAll(
      '[data-puja-step-indicator]'
    );

    const backButton = popup.querySelector(
      '[data-puja-step-back]'
    );

    const nextButton = popup.querySelector(
      '[data-puja-step-next]'
    );

    const submitButton = popup.querySelector(
      '[data-puja-sankalp-submit]'
    );

    const variantInput = popup.querySelector(
      '[data-puja-selected-variant]'
    );

    const packagePropertyInput = popup.querySelector(
      '[data-puja-property-package]'
    );

    const devoteeCountPropertyInput = popup.querySelector(
      '[data-puja-property-devotee-count]'
    );

    const devoteeContainer = popup.querySelector(
      '[data-puja-devotee-container]'
    );

    const sevaCards = popup.querySelectorAll(
      '[data-puja-seva-card]'
    );

    const bookingSummary = popup.querySelector(
      '[data-puja-booking-summary]'
    );

    const packageName = popup.querySelector(
      '[data-puja-summary-package-name]'
    );

    const packagePrice = popup.querySelector(
      '[data-puja-summary-package-price]'
    );

    const mobilePackageName = popup.querySelector(
        '[data-puja-mobile-package-name]'
    );

    const mobilePackagePrice = popup.querySelector(
        '[data-puja-mobile-package-price]'
    );

    const mobileStepIndicators = popup.querySelectorAll(
        '[data-puja-mobile-step]'
    );


    if (
      !form ||
      !variantInput ||
      !devoteeContainer
    ) {
      return;
    }


    /**
     * =========================================
     * STATE
     * =========================================
     */

    let currentStep = 1;

    let isSubmitting = false;

    const bookingStorageKey =
      `puja_booking_${window.location.pathname}`;

    const bookingToken =
      sessionStorage.getItem(
        `${bookingStorageKey}_token`
      ) ||
      (
        'PUJA-' +
        Date.now().toString(36) +
        '-' +
        Math.random()
          .toString(36)
          .substring(2, 8)
      ).toUpperCase();

      sessionStorage.setItem(
      `${bookingStorageKey}_token`,
      bookingToken
    );

    let selectedPackage = {
      variantId: variantInput.value || '',
      variantTitle:
        packageName
          ? packageName.textContent.trim()
          : '',
      variantPrice: 0,
      variantPriceFormatted:
        packagePrice
          ? packagePrice.textContent.trim()
          : '',
      devoteeCount: 1
    };


    /**
     * =========================================
     * HELPERS
     * =========================================
     */

    function escapeHtml(value) {

      if (
        value === null ||
        value === undefined
      ) {
        return '';
      }

      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

    }


    function formatMoney(cents) {

      const amount =
        Number(cents || 0) / 100;

      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-IN',
        {
          style: 'currency',
          currency:
            window.Shopify &&
            window.Shopify.currency &&
            window.Shopify.currency.active
              ? window.Shopify.currency.active
              : 'INR',
          maximumFractionDigits: 2
        }
      ).format(amount);

    }


    /**
     * =========================================
     * POPUP OPEN
     * =========================================
     */

    function openPopup(packageData) {

      if (packageData) {

        selectedPackage = {
          variantId:
            packageData.variantId || '',

          variantTitle:
            packageData.variantTitle || '',

          variantPrice:
            Number(
              packageData.variantPrice || 0
            ),

          variantPriceFormatted:
            packageData.variantPriceFormatted || '',

          devoteeCount:
            parseInt(
              packageData.devoteeCount,
              10
            ) || 1
        };

      }

        if (mobilePackageName) {
        mobilePackageName.textContent =
            selectedPackage.variantTitle;
        }

        if (mobilePackagePrice) {
        mobilePackagePrice.textContent =
            selectedPackage.variantPriceFormatted ||
            formatMoney(selectedPackage.variantPrice);
        }


      /**
       * Update variant input
       */

      variantInput.value =
        selectedPackage.variantId;


      /**
       * Update line item properties
       */

      if (packagePropertyInput) {

        packagePropertyInput.value =
          selectedPackage.variantTitle;

      }


      if (devoteeCountPropertyInput) {

        devoteeCountPropertyInput.value =
          selectedPackage.devoteeCount;

      }


      /**
       * Update package summary
       */

      if (packageName) {

        packageName.textContent =
          selectedPackage.variantTitle;

      }


      if (packagePrice) {

        packagePrice.textContent =
          selectedPackage.variantPriceFormatted ||
          formatMoney(
            selectedPackage.variantPrice
          );

      }


      /**
       * Generate devotee fields
       */

      const existingDevoteeCards =
        devoteeContainer.querySelectorAll(
          '[data-puja-devotee-card]'
        );


      const existingCount =
        existingDevoteeCards.length;


      if (
        existingCount !==
        selectedPackage.devoteeCount
      ) {

        generateDevoteeFields(
          selectedPackage.devoteeCount
        );

      }


      restoreBookingFormState();


      /**
       * Reset popup
       */

      currentStep = 1;

      updateSteps();


      /**
       * Open
       */

      popup.classList.add(
        'is-open'
      );

      popup.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.classList.add(
        'puja-sankalp-open'
      );


      /**
       * Focus modal
       */

      window.setTimeout(
        function () {

          if (modal) {

            const firstInput =
              modal.querySelector(
                'input, select, textarea, button'
              );

            if (firstInput) {
              firstInput.focus();
            }

          }

        },
        100
      );

    }


    /**
     * =========================================
     * POPUP CLOSE
     * =========================================
     */

    function closePopup() {

      popup.classList.remove(
        'is-open'
      );

      popup.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.classList.remove(
        'puja-sankalp-open'
      );

    }


    /**
     * =========================================
     * DYNAMIC DEVOTEE FIELDS
     * =========================================
     */

    function generateDevoteeFields(count) {

      devoteeContainer.innerHTML = '';

      const devoteeCount =
        parseInt(count, 10) || 1;


      for (
        let index = 1;
        index <= devoteeCount;
        index++
      ) {

        const devoteeNumber =
          `Devotee ${index}`;


        const devoteeHtml = `
          <div
            class="puja-devotee-card"
            data-puja-devotee-card="${index}"
          >

            <h4 class="puja-devotee-card-title">
              ${escapeHtml(devoteeNumber)}
            </h4>


            <div class="puja-sankalp-form-grid">


              <div class="puja-sankalp-field">

                <label>
                  Full Name ${index === 1 ? '<span>*</span>' : ''}
                </label>

                <input
                  type="text"
                  name="properties[Devotee ${index} Name]"
                  placeholder="Enter full name"
                  ${index === 1 ? 'required' : ''}
                  data-puja-devotee-name
                >

              </div>


              <div class="puja-sankalp-field">

                <label>
                  Gender ${index === 1 ? '<span>*</span>' : ''}
                </label>

                <select
                  name="properties[Devotee ${index} Gender]"
                  ${index === 1 ? 'required' : ''}
                  data-puja-devotee-gender
                >

                  <option value="">
                    Select gender
                  </option>

                  <option value="Male">
                    Male
                  </option>

                  <option value="Female">
                    Female
                  </option>

                  <option value="Other">
                    Other
                  </option>

                </select>

              </div>


              <div class="puja-sankalp-field">

                <label>
                  Gotra
                </label>

                <input
                  type="text"
                  name="properties[Devotee ${index} Gotra]"
                  placeholder="Enter Gotra"
                  data-puja-devotee-gotra
                >

              </div>

            </div>

          </div>
        `;


        devoteeContainer.insertAdjacentHTML(
          'beforeend',
          devoteeHtml
        );

      }

    }


    /**
     * =========================================
     * STEP NAVIGATION
     * =========================================
     */

    function updateSteps() {

      steps.forEach(
        function (step) {

          const stepNumber =
            parseInt(
              step.dataset.pujaStep,
              10
            );

          step.classList.toggle(
            'is-active',
            stepNumber === currentStep
          );

        }
      );


      stepIndicators.forEach(
        function (indicator) {

          const indicatorStep =
            parseInt(
              indicator.dataset.pujaStepIndicator,
              10
            );

          indicator.classList.toggle(
            'is-active',
            indicatorStep === currentStep
          );

          indicator.classList.toggle(
            'is-completed',
            indicatorStep < currentStep
          );

        }
      );

      mobileStepIndicators.forEach(
        function (indicator) {

            const indicatorStep = parseInt(
            indicator.dataset.pujaMobileStep,
            10
            );

            indicator.classList.toggle(
            'is-active',
            indicatorStep === currentStep
            );

            indicator.classList.toggle(
            'is-completed',
            indicatorStep < currentStep
            );

        }
        );


      /**
       * Footer buttons
       */

      if (backButton) {

        backButton.hidden =
          currentStep === 1;

      }


      if (nextButton) {

        nextButton.hidden =
          currentStep === 3;

      }


      if (submitButton) {

        submitButton.hidden =
          currentStep !== 3;

      }


      /**
       * Generate summary
       */

      if (currentStep === 3) {

        generateBookingSummary();

      }


      /**
       * Scroll active step to top
       */

      const activeStep =
        popup.querySelector(
          `[data-puja-step="${currentStep}"]`
        );

      if (activeStep) {

        activeStep.scrollTop = 0;

      }

    }


    /**
     * =========================================
     * VALIDATION
     * =========================================
     */

    function validateStep(stepNumber) {

      const step = popup.querySelector(
        `[data-puja-step="${stepNumber}"]`
      );

      if (!step) {
        return true;
      }

      let isValid = true;
      let firstInvalidField = null;

      /*
      * =========================================
      * HELPER
      * =========================================
      */

      function markInvalid(field) {

        if (!field) {
          return;
        }

        field.classList.add('is-error');

        if (!firstInvalidField) {
          firstInvalidField = field;
        }

        isValid = false;
      }


      function clearError(field) {

        if (field) {
          field.classList.remove('is-error');
        }

      }


      /*
      * =========================================
      * CLEAR OLD ERRORS
      * =========================================
      */

      step.querySelectorAll('.is-error').forEach(
        function(field) {
          field.classList.remove('is-error');
        }
      );


      /*
      * =========================================
      * STEP 1 VALIDATION
      * =========================================
      */

      if (stepNumber === 1) {

        /*
        * =========================================
        * DEVOTEE VALIDATION
        * =========================================
        *
        * Only Devotee 1 is required.
        * Devotee 2+ are optional.
        */

        const devoteeCards =
          devoteeContainer.querySelectorAll(
            '[data-puja-devotee-card]'
          );


        if (!devoteeCards.length) {

          isValid = false;

        } else {

          const firstDevotee =
            devoteeCards[0];

          const name =
            firstDevotee.querySelector(
              '[data-puja-devotee-name]'
            );

          const gender =
            firstDevotee.querySelector(
              '[data-puja-devotee-gender]'
            );


          /*
          * Devotee 1 Name
          */

          if (name) {

            const cleanName =
              name.value.trim();

            if (
              !cleanName ||
              cleanName.length < 2
            ) {

              markInvalid(name);

            } else {

              clearError(name);

            }

          }


          /*
          * Devotee 1 Gender
          */

          if (gender) {

            if (!gender.value) {

              markInvalid(gender);

            } else {

              clearError(gender);

            }

          }


          /*
          * Devotee 2+
          *
          * Optional.
          * Only validate if user has started
          * entering something.
          */

          Array.from(devoteeCards)
            .slice(1)
            .forEach(function(card) {

              const optionalName =
                card.querySelector(
                  '[data-puja-devotee-name]'
                );

              const optionalGender =
                card.querySelector(
                  '[data-puja-devotee-gender]'
                );


              /*
              * If optional name is entered,
              * don't force gender.
              *
              * If optional gender is selected,
              * don't force name.
              *
              * These fields are completely optional.
              */

              if (optionalName) {
                optionalName.classList.remove(
                  'is-error'
                );
              }

              if (optionalGender) {
                optionalGender.classList.remove(
                  'is-error'
                );
              }

            });

        }


        /*
        * =========================================
        * PHONE VALIDATION
        * =========================================
        */

        const phoneInput =
          popup.querySelector(
            '[data-puja-phone]'
          );


        if (phoneInput) {

          const phoneValue =
            phoneInput.value.trim();

          const phoneDigits =
            phoneValue.replace(
              /\D/g,
              ''
            );


          /*
          * Required
          */

          if (!phoneValue) {

            markInvalid(phoneInput);

          }

          /*
          * Invalid phone
          */

          else if (
            phoneDigits.length < 10 ||
            phoneDigits.length > 15
          ) {

            markInvalid(phoneInput);

          }

          else {

            clearError(phoneInput);

          }

        }


        /*
        * =========================================
        * EMAIL VALIDATION
        * =========================================
        */

        const emailInput =
          popup.querySelector(
            '[data-puja-email]'
          );


        if (emailInput) {

          const emailValue =
            emailInput.value.trim();


          /*
          * Required
          */

          if (!emailValue) {

            markInvalid(emailInput);

          }

          /*
          * Invalid email format
          */

          else if (
            !emailInput.checkValidity()
          ) {

            markInvalid(emailInput);

          }

          else {

            clearError(emailInput);

          }

        }

      }


      /*
      * =========================================
      * OTHER REQUIRED FIELDS
      * =========================================
      *
      * Only validate required fields that haven't
      * already been handled above.
      */

      step.querySelectorAll('[required]').forEach(
        function(field) {

          /*
          * Skip fields already handled
          */

          if (
            field.matches(
              '[data-puja-phone], [data-puja-email], [data-puja-devotee-name], [data-puja-devotee-gender]'
            )
          ) {
            return;
          }


          const value =
            typeof field.value === 'string'
              ? field.value.trim()
              : field.value;


          if (!value) {

            markInvalid(field);

            return;

          }


          if (
            typeof field.checkValidity === 'function' &&
            !field.checkValidity()
          ) {

            markInvalid(field);

          }

        }
      );


      /*
      * =========================================
      * FOCUS FIRST INVALID FIELD
      * =========================================
      */

      if (!isValid && firstInvalidField) {

        /*
        * Scroll field into view
        */

        firstInvalidField.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });


        /*
        * Focus after scroll
        */

        setTimeout(function() {

          try {

            firstInvalidField.focus({
              preventScroll: true
            });

          } catch (error) {

            firstInvalidField.focus();

          }

        }, 350);

      }


      return isValid;

    }

    function initValidationListeners() {

      const fields =
        form.querySelectorAll(
          'input, select, textarea'
        );


      fields.forEach(function (field) {

        field.addEventListener(
          'input',
          function () {

            if (
              field.value &&
              field.value.trim()
            ) {

              field.classList.remove(
                'is-error'
              );

            }

          }
        );


        field.addEventListener(
          'change',
          function () {

            if (field.value) {

              field.classList.remove(
                'is-error'
              );

            }

          }
        );

      });

    }


    /**
     * =========================================
     * OPTIONAL SEVA
     * =========================================
     */

    function initSevaCards() {

      sevaCards.forEach(
        function (card) {

          const input =
            card.querySelector(
              '[data-puja-seva-input]'
            );

          if (!input || input.disabled) {
            return;
          }


          card.addEventListener(
            'click',
            function () {

              /**
               * Let browser update checkbox first
               */

              window.setTimeout(
                function () {

                  card.classList.toggle(
                    'is-selected',
                    input.checked
                  );

                },
                0
              );

            }
          );


          input.addEventListener(
            'change',
            function () {

              card.classList.toggle(
                'is-selected',
                input.checked
              );

            }
          );

        }
      );

    }


    /**
     * =========================================
     * GET SELECTED SEVAS
     * =========================================
     */

    function getSelectedSevas() {

      const selectedSevas = [];


      sevaCards.forEach(
        function (card) {

          const input =
            card.querySelector(
              '[data-puja-seva-input]'
            );

          if (
            !input ||
            !input.checked ||
            input.disabled
          ) {
            return;
          }


          selectedSevas.push({
            productId:
              card.dataset.sevaProductId,

            variantId:
              card.dataset.sevaVariantId,

            title:
              card.dataset.sevaTitle,

            price:
              Number(
                card.dataset.sevaPrice || 0
              ),

            priceFormatted:
              card.dataset.sevaPriceFormatted
          });

        }
      );


      return selectedSevas;

    }


    /**
     * =========================================
     * GET DEVOTEE DATA
     * =========================================
     */

    function getDevoteeData() {

      const devotees = [];

      const cards =
        devoteeContainer.querySelectorAll(
          '[data-puja-devotee-card]'
        );


      cards.forEach(
        function (card, index) {

          const name =
            card.querySelector(
              '[data-puja-devotee-name]'
            );

          const gender =
            card.querySelector(
              '[data-puja-devotee-gender]'
            );

          const gotra =
            card.querySelector(
              '[data-puja-devotee-gotra]'
            );

          devotees.push({
            number: index + 1,

            name:
              name
                ? name.value
                : '',

            gender:
              gender
                ? gender.value
                : '',

            gotra:
              gotra
                ? gotra.value
                : ''
          });

        }
      );


      return devotees;

    }


    /**
     * =========================================
     * BOOKING SUMMARY
     * =========================================
     */

    function generateBookingSummary() {

      if (!bookingSummary) {
        return;
      }


      const devotees =
        getDevoteeData();

      const selectedSevas =
        getSelectedSevas();


      const phoneInput =
        popup.querySelector(
          '[data-puja-phone]'
        );

      const emailInput =
        popup.querySelector(
          '[data-puja-email]'
        );

      const messageInput =
        popup.querySelector(
          '[data-puja-special-message]'
        );


      let sevaTotal = 0;


      selectedSevas.forEach(
        function (seva) {

          sevaTotal += seva.price;

        }
      );


      const pujaPrice =
        Number(
          selectedPackage.variantPrice || 0
        );


      const grandTotal =
        pujaPrice + sevaTotal;


      let devoteesHtml = '';


      devotees.forEach(
        function (devotee) {

          devoteesHtml += `
            <div class="puja-summary-row">

              <span>
                Devotee ${devotee.number}
              </span>

              <strong>
                ${escapeHtml(devotee.name)}
                ${
                  devotee.gender
                    ? `(${escapeHtml(devotee.gender)})`
                    : ''
                }
              </strong>

            </div>
          `;

        }
      );


      let sevasHtml = '';


      if (selectedSevas.length) {

        selectedSevas.forEach(
          function (seva) {

            sevasHtml += `
              <div class="puja-summary-row">

                <span>
                  ${escapeHtml(seva.title)}
                </span>

                <strong>
                  ${
                    seva.priceFormatted ||
                    formatMoney(seva.price)
                  }
                </strong>

              </div>
            `;

          }
        );

      } else {

        sevasHtml = `
          <div class="puja-summary-row">

            <span>
              Optional Seva
            </span>

            <strong>
              None selected
            </strong>

          </div>
        `;

      }


      bookingSummary.innerHTML = `

        <div class="puja-summary-card">

          <h4>
            Puja Package
          </h4>


          <div class="puja-summary-row">

            <span>
              ${escapeHtml(
                selectedPackage.variantTitle
              )}
            </span>

            <strong>
              ${
                selectedPackage.variantPriceFormatted ||
                formatMoney(
                  selectedPackage.variantPrice
                )
              }
            </strong>

          </div>

        </div>


        <div class="puja-summary-card">

          <h4>
            Devotee Details
          </h4>

          ${devoteesHtml}

        </div>


        <div class="puja-summary-card">

          <h4>
            Contact Details
          </h4>


          <div class="puja-summary-row">

            <span>
              Phone
            </span>

            <strong>
              ${escapeHtml(
                phoneInput
                  ? phoneInput.value
                  : ''
              )}
            </strong>

          </div>


          <div class="puja-summary-row">

            <span>
              Email
            </span>

            <strong>
              ${escapeHtml(
                emailInput
                  ? emailInput.value
                  : ''
              )}
            </strong>

          </div>


          ${
            messageInput &&
            messageInput.value
              ? `
                <div class="puja-summary-row">

                  <span>
                    Special Message
                  </span>

                  <strong>
                    ${escapeHtml(
                      messageInput.value
                    )}
                  </strong>

                </div>
              `
              : ''
          }

        </div>


        <div class="puja-summary-card">

          <h4>
            Optional Seva
          </h4>

          ${sevasHtml}

        </div>


        <div class="puja-summary-total">

          <div class="puja-summary-row">

            <span>
              Total
            </span>

            <strong>
              ${
                formatMoney(
                  grandTotal
                )
              }
            </strong>

          </div>

        </div>

      `;

    }

    function saveBookingFormState() {

      const state = {

        variantId:
          selectedPackage.variantId,

        devoteeData:
          getDevoteeData(),

        phone:
          popup.querySelector(
            '[data-puja-phone]'
          )?.value || '',

        email:
          popup.querySelector(
            '[data-puja-email]'
          )?.value || '',

        specialMessage:
          popup.querySelector(
            '[data-puja-special-message]'
          )?.value || '',

        sevas:
          getSelectedSevas()
            .map(
              function (seva) {
                return String(
                  seva.variantId
                );
              }
            )

      };


      sessionStorage.setItem(
        `${bookingStorageKey}_state`,
        JSON.stringify(state)
      );

    }

    function restoreBookingFormState() {

      const rawState =
        sessionStorage.getItem(
          `${bookingStorageKey}_state`
        );


      if (!rawState) {
        return;
      }


      let state;


      try {

        state =
          JSON.parse(rawState);

      } catch (error) {

        console.warn(
          'Invalid saved Puja booking state.',
          error
        );

        sessionStorage.removeItem(
          `${bookingStorageKey}_state`
        );

        return;

      }


      /*
      * Only restore for same variant.
      */

      if (
        state.variantId !==
        selectedPackage.variantId
      ) {

        return;

      }


      /*
      * Contact details
      */

      const phone =
        popup.querySelector(
          '[data-puja-phone]'
        );

      const email =
        popup.querySelector(
          '[data-puja-email]'
        );

      const message =
        popup.querySelector(
          '[data-puja-special-message]'
        );


      if (phone) {
        phone.value =
          state.phone || '';
      }

      if (email) {
        email.value =
          state.email || '';
      }

      if (message) {
        message.value =
          state.specialMessage || '';
      }


      /*
      * Devotees
      */

      if (
        Array.isArray(
          state.devoteeData
        )
      ) {

        state.devoteeData.forEach(
          function (
            devotee,
            index
          ) {

            const card =
              devoteeContainer.querySelector(
                `[data-puja-devotee-card="${index + 1}"]`
              );


            if (!card) {
              return;
            }


            const name =
              card.querySelector(
                '[data-puja-devotee-name]'
              );

            const gender =
              card.querySelector(
                '[data-puja-devotee-gender]'
              );

            const gotra =
              card.querySelector(
                '[data-puja-devotee-gotra]'
              );


            if (name) {
              name.value =
                devotee.name || '';
            }

            if (gender) {
              gender.value =
                devotee.gender || '';
            }

            if (gotra) {
              gotra.value =
                devotee.gotra || '';
            }

          }
        );

      }


      /*
      * Restore Seva selection
      */

      if (
        Array.isArray(state.sevas)
      ) {

        sevaCards.forEach(
          function (card) {

            const input =
              card.querySelector(
                '[data-puja-seva-input]'
              );


            if (!input) {
              return;
            }


            const sevaVariantId =
              String(
                card.dataset.sevaVariantId ||
                ''
              );


            input.checked =
              state.sevas.includes(
                sevaVariantId
              );


            card.classList.toggle(
              'is-selected',
              input.checked
            );

          }
        );

      }

    }

    function initBookingStateListeners() {

      form.addEventListener(
        'input',
        function () {

          saveBookingFormState();

        }
      );


      form.addEventListener(
        'change',
        function () {

          saveBookingFormState();

        }
      );

    }


    /**
     * =========================================
     * ADD ITEMS TO CART
     * =========================================
     */

    async function getCart() {

      const response =
        await fetch(
          '/cart.js',
          {
            method: 'GET',
            headers: {
              'Accept':
                'application/json'
            },
            cache: 'no-store'
          }
        );


      if (!response.ok) {

        throw new Error(
          'Unable to verify your cart. Please try again.'
        );

      }


      return response.json();

    }

    async function removePreviousBooking() {

      const cart =
        await getCart();


      if (
        !cart ||
        !Array.isArray(cart.items) ||
        !cart.items.length
      ) {

        return;

      }


      const lineUpdates = {};


      cart.items.forEach(
        function (item) {

          const properties =
            item.properties || {};


          /*
          * Shopify private properties
          * begin with "_".
          */

          if (
            properties['_Puja Booking Token'] ===
            bookingToken
          ) {

            lineUpdates[item.key] = 0;

          }

        }
      );


      if (
        !Object.keys(lineUpdates).length
      ) {

        return;

      }


      const response =
        await fetch(
          '/cart/update.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              'Accept':
                'application/json'
            },

            body: JSON.stringify({
              updates: lineUpdates
            })
          }
        );


      if (!response.ok) {

        throw new Error(
          'Unable to update your previous booking. Please try again.'
        );

      }

    }

    async function addBookingToCart() {

      /*
      * =========================================
      * FINAL VALIDATION
      * =========================================
      */

      if (!validateStep(1)) {

        currentStep = 1;

        updateSteps();

        throw new Error(
          'Please complete all required devotee details.'
        );

      }


      /*
      * =========================================
      * VALIDATE VARIANT
      * =========================================
      */

      const variantId =
        Number(
          selectedPackage.variantId
        );


      if (
        !Number.isInteger(variantId) ||
        variantId <= 0
      ) {

        throw new Error(
          'Invalid Puja package selected. Please select a package again.'
        );

      }


      /*
      * =========================================
      * SELECTED SEVAS
      * =========================================
      */

      const selectedSevas =
        getSelectedSevas();


      /*
      * Validate Seva variant IDs
      */

      for (
        const seva of selectedSevas
      ) {

        const sevaVariantId =
          Number(seva.variantId);


        if (
          !Number.isInteger(
            sevaVariantId
          ) ||
          sevaVariantId <= 0
        ) {

          throw new Error(
            'One of the selected Seva items is no longer available. Please review your Seva selection.'
          );

        }

      }


      /*
      * =========================================
      * FORM DATA
      * =========================================
      */

      const formData =
        new FormData(form);


      const properties = {};


      formData.forEach(
        function (value, key) {

          if (
            !key.startsWith(
              'properties['
            )
          ) {

            return;

          }


          const propertyName =
            key
              .replace(
                'properties[',
                ''
              )
              .replace(
                ']',
                ''
              );


          /*
          * Don't send empty values.
          */

          if (
            value !== null &&
            value !== undefined &&
            String(value).trim() !== ''
          ) {

            properties[propertyName] =
              String(value).trim();

          }

        }
      );


      /*
      * =========================================
      * BOOKING IDENTIFIER
      * =========================================
      *
      * Private Shopify property.
      * This is NOT displayed to customers
      * in normal cart UI.
      */

      properties[
        '_Puja Booking Token'
      ] = bookingToken;


      properties[
        '_Puja Booking'
      ] = 'true';


      /*
      * =========================================
      * OPTIONAL SEVAS
      * =========================================
      */

      if (selectedSevas.length) {

        properties[
          'Selected Optional Sevas'
        ] =
          selectedSevas
            .map(
              function (seva) {
                return seva.title;
              }
            )
            .join(', ');

      }


      /*
      * =========================================
      * CART ITEMS
      * =========================================
      */

      const items = [];


      /*
      * Main Puja
      */

      items.push({

        id: variantId,

        quantity: 1,

        properties: properties

      });


      /*
      * Optional Sevas
      *
      * IMPORTANT:
      * Give every Seva the same private
      * booking token so they can be removed
      * together when user modifies booking.
      */

      selectedSevas.forEach(
        function (seva) {

          items.push({

            id:
              Number(
                seva.variantId
              ),

            quantity: 1,

            properties: {

              '_Puja Booking Token':
                bookingToken,

              '_Puja Booking':
                'true'

            }

          });

        }
      );


      /*
      * =========================================
      * REMOVE OLD VERSION
      * =========================================
      */

      await removePreviousBooking();


      /*
      * =========================================
      * ADD NEW VERSION
      * =========================================
      */

      const response =
        await fetch(
          '/cart/add.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              'Accept':
                'application/json'
            },

            body:
              JSON.stringify({
                items: items
              })
          }
        );


      /*
      * =========================================
      * ERROR HANDLING
      * =========================================
      */

      let responseData = null;


      try {

        responseData =
          await response.json();

      } catch (parseError) {

        responseData = null;

      }


      if (!response.ok) {

        console.error(
          'Shopify Cart API error:',
          responseData
        );


        throw new Error(
          responseData?.description ||
          responseData?.message ||
          'Unable to add your Puja booking to cart. Please try again.'
        );

      }


      /*
      * Save successful booking state
      */

      sessionStorage.setItem(
        `${bookingStorageKey}_submitted`,
        'true'
      );


      return responseData;

    }


    /**
     * =========================================
     * BUTTON EVENTS
     * =========================================
     */

    if (nextButton) {

      nextButton.addEventListener(
        'click',
        function () {

          if (
            !validateStep(
              currentStep
            )
          ) {
            return;
          }


          if (currentStep < 3) {

            currentStep += 1;

            updateSteps();

          }

        }
      );

    }


    if (backButton) {

      backButton.addEventListener(
        'click',
        function () {

          if (currentStep > 1) {

            currentStep -= 1;

            updateSteps();

          }

        }
      );

    }


    /**
     * =========================================
     * FORM SUBMIT
     * =========================================
     */

    form.addEventListener(
      'submit',
      async function (event) {

        event.preventDefault();


        /*
        * Prevent double-click / double submit
        */

        if (isSubmitting) {
          return;
        }


        /*
        * Validate Step 1
        */

        if (!validateStep(1)) {

          currentStep = 1;

          updateSteps();

          return;

        }


        /*
        * Make sure we are on confirmation
        */

        if (currentStep !== 3) {

          currentStep = 3;

          updateSteps();

          return;

        }


        if (!submitButton) {

          console.error(
            'Puja submit button not found.'
          );

          return;

        }


        isSubmitting = true;


        const originalText =
          submitButton.innerHTML;


        submitButton.disabled = true;

        submitButton.setAttribute(
          'aria-busy',
          'true'
        );

        submitButton.innerHTML =
          `
            <span class="puja-submit-spinner"
                  aria-hidden="true">
            </span>
            Processing...
          `;


        try {

          /*
          * Rebuild summary immediately
          * before checkout.
          */

          generateBookingSummary();


          /*
          * Add/update cart
          */
          saveBookingFormState();

          await addBookingToCart();


          /*
          * Redirect only after successful
          * Shopify response.
          */

          window.location.assign(
            '/checkout'
          );


        } catch (error) {

          console.error(
            'Puja booking error:',
            error
          );


          /*
          * User-friendly message
          */

          alert(
            error?.message ||
            'Something went wrong while processing your booking. Please try again.'
          );


          isSubmitting = false;


          submitButton.disabled = false;

          submitButton.removeAttribute(
            'aria-busy'
          );

          submitButton.innerHTML =
            originalText;

        }

      }
    );


    /**
     * =========================================
     * CLOSE EVENTS
     * =========================================
     */

    closeButtons.forEach(
      function (button) {

        button.addEventListener(
          'click',
          closePopup
        );

      }
    );


    /**
     * ESC KEY
     */

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          popup.classList.contains(
            'is-open'
          )
        ) {

          closePopup();

        }

      }
    );


    /**
     * =========================================
     * LISTEN TO PUJA PACKAGE SECTION
     * =========================================
     */

    document.addEventListener(
      'puja:booking:start',
      function (event) {

        const packageData =
          event.detail || {};


        if (
          !packageData.variantId
        ) {
          return;
        }


        openPopup(
          packageData
        );

      }
    );


    /**
     * =========================================
     * INITIALIZE
     * =========================================
     */

    initSevaCards();

    initValidationListeners();

    initBookingStateListeners();

    popup.dataset.initialized = 'true';

  });

}


/**
 * =========================================
 * THEME EDITOR / PAGE INITIALIZATION
 * =========================================
 */

document.addEventListener(
  'DOMContentLoaded',
  initPujaSankalpPopup
);


document.addEventListener(
  'shopify:section:load',
  initPujaSankalpPopup
);